import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;